import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2246e00a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "section-header" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "section-header" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "video"
}
const _hoisted_10 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_ctx.headers.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.headers.length === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("section", {
                class: "section cta-section grid grid-cols-2 sm-grid-cols-1 md-grid-cols-1",
                style: _normalizeStyle(_ctx.headers[0].backgroundImage ? `background: linear-gradient(#101823ac, #101823ac), url('${_ctx.headers[0].backgroundImage}');` : '')
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.headers[0].heading), 1),
                  _createElementVNode("h2", null, _toDisplayString(_ctx.headers[0].title), 1),
                  _createElementVNode("div", {
                    innerHTML: _ctx.headers[0].content
                  }, null, 8, _hoisted_5)
                ])
              ], 4)
            ]))
          : (_openBlock(), _createBlock(_component_swiper, {
              key: 1,
              modules: _ctx.modules,
              "slides-per-view": 1,
              "space-between": 0,
              loop: true,
              pagination: { clickable: true },
              navigation: true,
              autoplay: { delay: 5000, disableOnInteraction: false },
              class: "header-swiper"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
                  return (_openBlock(), _createBlock(_component_swiper_slide, { key: index }, {
                    default: _withCtx(() => [
                      _createElementVNode("section", {
                        class: "section cta-section grid grid-cols-2 sm-grid-cols-1 md-grid-cols-1",
                        style: _normalizeStyle(header.backgroundImage ? `background: linear-gradient(#101823ac, #101823ac), url('${header.backgroundImage}');` : '')
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("h3", _hoisted_7, _toDisplayString(header.heading), 1),
                          _createElementVNode("h2", null, _toDisplayString(header.title), 1),
                          _createElementVNode("div", {
                            innerHTML: header.content
                          }, null, 8, _hoisted_8)
                        ]),
                        (header.video)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createVNode(_component_router_link, {
                                to: { name: 'video-detail', params: { slug: header.video.slug }}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    src: header.video.thumbnail,
                                    alt: header.video.title
                                  }, null, 8, _hoisted_10)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                          : _createCommentVNode("", true)
                      ], 4)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["modules"]))
      ]))
    : _createCommentVNode("", true)
}